import { useEffect } from "react";

const DocsRedirect = () => {
    useEffect(() => {
        window.location.href = 'https://docs.looq.ai/';
    }, []);
    return (<></>);
}

export default DocsRedirect;